import {useEffect, useRef, useState} from "react";
import {chatApi} from "@/api";
import Preloader from "@UI/Preloader";
import Button from "@UI/Button";
import classNames from "classnames";
import classes from "@pages/Admin/AllUsers/modals/EditStudentModal/index.module.css";
import Select from "@UI/New/Select";
import styles from './../StudentChatsTab.module.css';
import style from './ModalStudentChatsTab.module.css';
import TextField from "@pages/Admin/CourseSettings/components/TextField/TextField";

const ROLE_OPTIONS = [
    { value: 1, label: 'Участник' },
    { value: 2, label: 'Администратор' },
    { value: 3, label: 'Читатель' },
]


export const AddChatModal = ({ studentId, onClose, onSave }) => {
    const [results, setResults]   = useState([])
    const [selectedChat, setSelected] = useState(null)
    const [role, setRole]         = useState(1)
    const [searching, setSearching] = useState(false)

    useEffect(() => {
        const fetchChats = async () => {
            setSearching(true)
            try {
                const res = await chatApi.getUserChatNameList({
                    type: 'group',
                    user_id: studentId,
                })
                const all = Array.isArray(res.data) ? res.data : (res.data?.data ?? [])
                setResults(all)
            } catch {
                setResults([])
            } finally {
                setSearching(false)
            }
        }
        fetchChats()
    }, [studentId])

    const handleSelect = (value) => {
        const chat = results.find((c) => c.id === value)
        if (chat) setSelected(chat)
    }

    return (
        <div className={style['modal__wrapper']}>
            <h2>Добавление в групповой чат</h2>

            <div className={style['modal__body']}>
                <label>Введите название группового чата</label>
                <Select
                    fields={{
                        loading: searching,
                        placeholder: 'Выберите чат...',
                        value: selectedChat?.id ?? undefined,
                        options: results.map((chat) => ({
                            value: chat.id,
                            label: chat.title ?? chat.name,
                        })),
                        onChange: handleSelect,
                    }}
                />

                <label>Роль в чате</label>
                <Select
                    fields={{
                        value: role,
                        options: ROLE_OPTIONS,
                        onChange: (value) => setRole(value),
                    }}
                />
            </div>

            <div className={style['modal__footer']}>
                <Button newDesign className={classNames(classes.secondaryButton, classes.truncateText)} onClick={onClose}>
                    Отмена
                </Button>
                <Button
                    newDesign
                    className={classNames(
                        classes.primaryButton,
                        classes.truncateText,
                        !selectedChat && styles.disabledButton,
                    )}
                    onClick={() => selectedChat && onSave({ chat: selectedChat, role })}
                    disabled={!selectedChat}
                >
                    Сохранить
                </Button>
            </div>
        </div>
    )
}

export const EditRoleModal = ({ chat, onClose, onSave }) => {
    const [role, setRole] = useState(chat?.member?.role ?? 1)

    return (
        <div className={style['modal__wrapper']}>
            <div className={style['modal__header']}>
                <h2 className={style['modal__header-title']}>Изменить роль в чате</h2>
                <div>
                    Чат: <strong>{chat?.title ?? chat?.name}</strong>
                </div>
            </div>
            <div className={style['modal__body']}>
                <h3>Роль в чате</h3>
                <Select
                    fields={{
                        value: role,
                        options: ROLE_OPTIONS,
                        onChange: (value) => setRole(value),
                    }}
                />
            </div>
            <div className={style['modal__footer']}>
                <Button newDesign className={classNames(classes.secondaryButton, classes.truncateText)} onClick={onClose}>
                    Отмена
                </Button>
                <Button newDesign className={classNames(classes.primaryButton, classes.truncateText)} onClick={() => onSave(role)}>
                    Сохранить
                </Button>
            </div>
        </div>
    )
}